// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"FAQ_FAQ__cQhrs","entry":"FAQ_entry__E12VV","question":"FAQ_question__kx4JY","icon":"FAQ_icon__b5d7q","answer":"FAQ_answer__tGqBk"};